import {IntervalsRoomRequest} from '../../../coreGlobal/models/room'
import {TAdminRoomForm, TAdminRoomRequest} from './_models'

const formatIntervals = (intervals: IntervalsRoomRequest[][] = []) => {
  return intervals.flatMap((dayIntervals, day) =>
    dayIntervals ? dayIntervals.map((interval) => ({...interval, day})) : []
  )
}

export const BuildRequest = (data: TAdminRoomForm): TAdminRoomRequest => {
  return {
    franchise: data.franchise,
    name: data.name,
    syncName: data.syncName,
    color: data.color,
    categories: data.categories,
    products: data.products,
    ...(data.machines?.length && {machines: data.machines}),
    intervals: formatIntervals(data.intervals),
    maxScheduleDate: data.maxScheduleDate,
  }
}
